export default __webpack_public_path__ + "static/media/format-align-justify.6cc2fcd8.svg";